import { FC } from 'react'
import tTarasenkoImg from 'assets/img/tetiana-tarasenko.jpg'

const Texts: FC = () => {
    return (
        <div className="texts-page">
            <article>	
                <div className="main">
                    <div>
                        <h1>Tatiana Tarasenko's male nude</h1>
                        <p>Shakespeare. Sonnet XXIV
                        Mine eye hath play'd the painter and hath stell'd
                        Thy beauty's form in table of my heart;
                        My body is the frame wherein 'tis held,
                        And perspective it is the painter's art.
                        For through the painter must you see his skill,
                        To find where your true image pictured lies;
                        Which in my bosom's shop is hanging still,
                        That hath his windows glazed with thine eyes.
                        Now see what good turns eyes for eyes have done:
                        Mine eyes have drawn thy shape, and thine for me
                        Are windows to my breast, where-through the sun
                        Delights to peep, to gaze therein on thee;
                        Yet eyes this cunning want to grace their art;
                        They draw but what they see, know not the heart.</p> 
                    </div>
                    <img src={tTarasenkoImg} alt="Tetiana Tarasenko" />
                </div>
                <p>Worshiping the human body Tetiana Tarasenko recreated it in her numerous man sketches and accumulated in them
                all her professional knowledge, talent, compositional skills, graphic mastery.
                The most artist's paintings created in recent years, were inspired with erotism and coloured with gender shadowing.
                That is male nude.Sometimessymbolism hiddenly(“The Thistle Flavour”) and sometimes explicitly(“Love”) there
                stated a woman presence. Expressionist works don't veil passion mixed with the sensual and sometimes gloomy
                symbolism(“The Solitude”,”The Speculalar Captivity”). They embody motion and philosophical artistry(“Between
                sky and ground”,”Nude”,”Sonnet”).</p> 
                <p>Being a supporter of expressive manner of writing, Tatiana comes from emotions. At times her prolonged and
                durable redrawing the art-pieces does not give the expected result. In such a case the artist postpones the canvas
                turned to a wall and waits for a flash of inspiration till the soul, hand and eye become ripe and ready to reach the
                resonance with the original idea. And a few hours enough to complete the work. The viewer is offered a holistic
                picture professionally balanced in its ways of expression. The colours, wide volumetric dab, accents of line and
                spot that make the individual nodes of human figure more expressive are subordinated to refined passionate
                emotions. Sometimes the artist cannot help the ornamented drips of liquid paint affirming her right for gravitation.</p> 
                <p>Shakespeare's poetry where the anthem of love sounds in the orchestra of vital joy and bitterness, passion
                and wisdom is an additional incentive for Tetiana. To feel the genius of Shakespeare deeper Tatiana learns English
                reading poems in the original. As a result she embeds favorite verses onto the surface of her canvases.</p> 
                <p><b>Ph.D. In History of Arts</b></p> 
                <p><b>Halina Kusko</b></p>	

                <section>
                    <h4>Links</h4>
                    <a href="https://wz.lviv.ua/interview/392143-yak-tilky-beru-v-ruky-penzel-zabuvaiu-pro-vse-tse-unikalno?fbclid=IwAR3eo4360rJw0rE92Vr4kvvCPfqKn1pX1LXo7N809JH_X3C5Q7XfgYwDugE"> Як тільки беру в руки пензель — забуваю про все. Це унікально! (UA) </a>
                    <a href="https://wz.lviv.ua/article/142021-cholovichi-figuri-shcho-nagaduyut-balerin-dega?fbclid=IwAR2XVEH08-tlDqMroQMb-7pskw327fOMHCdzn09UKtWfL0Iyc3MeBaMFLWw"> Чоловічі фігури, що нагадують балерин Дега (UA) </a>
                    <a href="https://wz.lviv.ua/news/381986-statuyu-skorbotnogo-khrista-ne-restavruvali-400-rokiv?fbclid=IwAR1ko0WhyCqXUrypfL3OlPOy3OL9HJUzfaHL7CSwo8qql9tHtqVsk6jN71k"> Статую Скорботного Христа не реставрували 400 років!(UA) </a>
                    <a href="https://wz.lviv.ua/news/376193-onuk-petro-nadiv-moi-dzerkalni-okuliary-i-v-mene-odrazu-narodylasia-ideia-ioho-portreta?fbclid=IwAR2LvubMItBBTSY7ClomvpZWhPgYnY6NVo3kB3HTvGWVWy7mPKpb5ZTw07A"> У Львові відкрилася персональна виставка відомої львівської художниці Тетяни Тарасенко (UA) </a>
                </section>
                
            </article>
        </div>
    )
}

export default Texts
